import {Module} from "vuex";
import {RootState} from "@/store/types";
import {viberTemplate} from "@/store/viber/templates";
import {viberStatistic} from "@/store/viber/statistic";

export const viberModule: Module<any, RootState> = {
  modules: {
    viberTemplate,
    viberStatistic,
  }
}
